export default {"src":"/_next/static/media/next.ecfdd40c.svg","height":22,"width":12};